import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { paymentGatewayApi } from "../API/paymentGatewayApi";
import subscriptionApi from "../API/subscriptionApi";
import { currentTenant } from "../Common/Credentials";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import TextfieldComponent from "../Component/TextfieldComponent";
import Breadcrumb from "../NewUI/NewComponents/Breadcrumb";
import SelectField from "../NewUI/NewComponents/SelectField";
import Swal from "sweetalert2";

export default function SubscriptionForm() {
  const navigate = useNavigate();
  const [gateways, setGateways] = useState([]);
  const [form, setForm] = useState({
    tenantId: currentTenant || "",
    customerId: "",
    gatewayId: "",
    subscriptionPlanId: "",
    subscriptionName: "",
    autoRenew: true,
    startDate: "",
    remarks: "",
  });

  useEffect(() => {
    paymentGatewayApi.getAll().then((res) => {
      const list = res.data?.data || res.data || [];
      setGateways([...list].sort((a, b) => (a.priority ?? 9999) - (b.priority ?? 9999)));
    }).catch(() => {});
  }, []);

  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  // Default to top-priority active gateway on create
  useEffect(() => {
    if (!form.gatewayId && gateways.length > 0) {
      const top = gateways.find((g) => g.active !== false) || gateways[0];
      if (top) setForm((p) => (p.gatewayId ? p : { ...p, gatewayId: top.id }));
    }
  }, [gateways]);

  const submit = async () => {
    if (!form.tenantId?.trim() || !form.customerId?.trim() || !form.gatewayId || !form.subscriptionPlanId?.trim()) {
      Swal.fire("Tenant, Customer, Gateway and Plan ID are required", "", "warning");
      return;
    }
    try {
      const payload = { ...form };
      if (!payload.startDate) delete payload.startDate;
      else payload.startDate = new Date(payload.startDate + 'T00:00:00Z').toISOString();
      await subscriptionApi.create(payload);
      Swal.fire("Subscription created", "", "success").then(() => navigate("/subscriptionslist"));
    } catch (e) {
      Swal.fire(e?.response?.data?.message || "Create failed", "", "error");
    }
  };

  return (
    <div>
      <Header />
      <Menu />
      <div className="content-wrapper">
        <div className="UI-container">
          <div className="UI-header">
            <Breadcrumb breadcrumbs={[{ name: "Home", path: "/superadminmasters" }, { name: "Subscriptions", path: "/subscriptionslist" }, { name: "Create", path: null }]} />
          </div>
          <div className="UI-form-card">
            <div className="form-row">
              <fieldset className="col-md-3">
                <TextfieldComponent type="text" name="tenantId" label="Tenant ID" value={form.tenantId} onChange={(e) => set("tenantId", e.target.value)} required />
              </fieldset>
              <fieldset className="col-md-3">
                <TextfieldComponent type="text" name="customerId" label="Customer ID" value={form.customerId} onChange={(e) => set("customerId", e.target.value)} required />
              </fieldset>
              <fieldset className="col-md-3">
                <SelectField label="Gateway" list={gateways} lableKey="displayName" lableValue="id" value={form.gatewayId} onChange={(e) => set("gatewayId", e.target.value)} required />
              </fieldset>
              <fieldset className="col-md-3">
                <TextfieldComponent type="text" name="subscriptionPlanId" label="Subscription Plan ID" value={form.subscriptionPlanId} onChange={(e) => set("subscriptionPlanId", e.target.value)} required />
              </fieldset>
              <fieldset className="col-md-3">
                <TextfieldComponent type="text" name="subscriptionName" label="Subscription Name" value={form.subscriptionName} onChange={(e) => set("subscriptionName", e.target.value)} />
              </fieldset>
              <fieldset className="col-md-3">
                <TextfieldComponent type="date" name="startDate" label="Start Date" value={form.startDate} onChange={(e) => set("startDate", e.target.value)} />
              </fieldset>
              <fieldset className="col-md-12">
                <TextfieldComponent type="text" name="remarks" label="Remarks" value={form.remarks} onChange={(e) => set("remarks", e.target.value)} />
              </fieldset>
              <fieldset className="col-md-3">
                <div className="UI-form-group tw-pb-1">
                  <label className="UI-label">Auto Renew</label>
                  <div className="tw-flex tw-items-center tw-gap-2 tw-pt-2">
                    <input type="checkbox" className="tw-w-5 tw-h-5 tw-accent-[#fdd60e] tw-cursor-pointer" checked={form.autoRenew} onChange={(e) => set("autoRenew", e.target.checked)} />
                    <span className="tw-text-sm">{form.autoRenew ? "Yes" : "No"}</span>
                  </div>
                </div>
              </fieldset>
              <fieldset className="col-md-12 tw-flex tw-justify-end">
                <button className="UI-btn UI-btn-primary tw-mr-2" type="button" onClick={submit}>Create</button>
                <Link as="button" className="UI-btn UI-btn-outline col-md-auto col-sm-12" to={{ pathname: "/subscriptionslist" }}>Cancel</Link>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
